module.exports = __webpack_public_path__ + "images/fa-mobile-course-certificate.jpg";